import { render, staticRenderFns } from "./merdekaDialog.vue?vue&type=template&id=08a27dfb&scoped=true"
import script from "./merdekaDialog.vue?vue&type=script&lang=js"
export * from "./merdekaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a27dfb",
  null
  
)

export default component.exports